// extracted by mini-css-extract-plugin
var _1 = "EpostFormContent-modulecontentWrapper__NaUDf Content-modulecontentWrapper__p1AMw";
var _2 = "EpostFormContent-moduleformBody__JNpIP";
export { _1 as "contentWrapper", _2 as "formBody" }
